import styled from 'styled-components';

import { ModalBody } from '../../../components/DialogRoundedModal';

const OptionsContainer = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  padding-bottom: 0;
`;

export {
  OptionsContainer,
};
